import { render, staticRenderFns } from "./Words.vue?vue&type=template&id=3f81e4e2&scoped=true&"
import script from "./Words.vue?vue&type=script&lang=js&"
export * from "./Words.vue?vue&type=script&lang=js&"
import style0 from "./Words.vue?vue&type=style&index=0&id=3f81e4e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f81e4e2",
  null
  
)

export default component.exports